// extracted by mini-css-extract-plugin
export default {"loading":"index__loading--uT2UM"};